/**
 * Thin bridge into raftor_websitehq's own colour-swatch logic -- NOT a
 * second implementation. Colour swatches are product-card visuals, and
 * websitehq owns product cards outright (see its own product_card/
 * register.js, which exposes exactly these two functions on
 * window.rfhqProductCard.adapters.webshop). This app has no business
 * keeping its own copy of the colour-name-guessing map or the override
 * fetch; the two legacy renderers here that still need colour (listing
 * cards via product_variant_swatches.js, the PDP via
 * pdp_variant_swatches.js -- surfaces websitehq doesn't cover, or predates)
 * call through this bridge instead.
 *
 * Same degrade-safely-in-both-directions contract as owned_surface.js's
 * window.webhqOwnedSurface: with websitehq absent, colour swatches simply
 * render as plain grey circles (the same "guess failed" fallback these
 * callers already use) instead of a duplicated, always-out-of-sync guessing
 * heuristic living in two apps.
 */

export function resolveSwatchColor(name, overrides) {
	var target = window.rfhqProductCard && window.rfhqProductCard.adapters.webshop.resolveSwatchColor;
	return target ? target(name, overrides) : null;
}

export function getSwatchColorOverrides() {
	var target = window.rfhqProductCard && window.rfhqProductCard.adapters.webshop.getSwatchColorOverrides;
	return target ? target() : Promise.resolve({});
}
